import { Color } from "@starrez/starryui";
import styled from "styled-components";

export const SummaryPanelDiv = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    padding: 16px;
    word-break: break-word;
`;

export const SummaryTitleDiv = styled.div`
    font-size: 16px !important;
    font-weight: 700;
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const SummaryTitleH2 = styled.h2`
    font-size: 18px !important;
    font-weight: 700;
    padding-bottom: 8px;
    margin-bottom: 8px;
    flex: 1;
`;

export const SummaryDetailsDiv = styled.div`
    font-size: 14px !important;
    line-height: 1.4em;
`;

export const SummaryFieldDiv = styled.div`
    padding-bottom: 24px;
    color: ${Color.Grey.G80};
`;

export const SummaryFieldSpan = styled.span`
    color: ${Color.Grey.G60};
    margin-bottom: 8px;
    display: block;
`;

export const SummaryFieldFooterSpan = styled.span`
    color: ${Color.Grey.G60};
    font-size: 14px !important;
`;
